<template>
  <el-dialog :model-value="show"
             title="Full Terms"
             class="cus-el-dialog"
             :append-to-body="false"
             width="680"
             height="600"
             :before-close="handleClose">
    <el-scrollbar>
      <SpDivider :width="1" class="mg-b-30" direction="horizen" :opacity="0.3" />
      <div style="white-space: pre-wrap; min-height: 500px" v-html="fullTerm" />
    </el-scrollbar>
  </el-dialog>
</template>

<script>
import { ref, watch } from 'vue'
import { cargoOrderTctInformationdAllApi } from '../../../request/APIs/boAndOp'
import SpDivider from '../SpDivider'

export default {
  name: 'FullTerm',
  components: { SpDivider },
  props: {
    show: Boolean,
    orderId: String | Number
  },

  emits: ['close'],
  setup (props, ctx) {
    const handleClose = () => {
      ctx.emit('close')
    }
    const fullTerm = ref('')
    watch(() => props.show, nv => {
      if (nv) {
        getCargoOrderDetail()
      }
    })
    const getCargoOrderDetail = () => {
      cargoOrderTctInformationdAllApi(props.orderId).then(res => {
        if (res.code === 1) {
          fullTerm.value = res.data.term.content
        }
      })
    }
    return {
      fullTerm,
      getCargoOrderDetail,
      handleClose
    }
  }
}
</script>

<style scoped>

</style>
